/**
 * debriefBranch.js
 *
 * DEAD SIGNAL — Which debrief beat the interview earned.
 *
 * The debrief plays differently depending on what actually happened at the
 * interference gate. Hot categories are the overwrite tier; warm categories
 * classify but deliver. hasRoutedAround records that the player got a
 * substantive thread through after being suppressed (set by the interview
 * manager). Pure module with no store or content imports so the node test
 * harness can exercise it directly.
 */

const HOT_CATEGORIES = new Set([
  'clinical_trial_st_erasmus',
  'chip_interference',
  'helios_secrets',
]);

/**
 * Select the debrief branch from an interview state snapshot.
 *
 *   'A'  overwritten and never worked around: Craine catches the lie with his eyes.
 *   'B'  adapted: Craine noticed the chip talking different, not a malfunction.
 *   'C'  both: overwritten at least once AND adapted.
 *   null no suppression registered: no interference beat in the debrief.
 *
 * @param {object} interview  store.interview snapshot
 * @returns {'A'|'B'|'C'|null}
 */
export function selectDebriefBranch(interview) {
  const iv = interview || {};
  const hot = (iv.suppressedMessages || []).some((m) => HOT_CATEGORIES.has(m.category));
  const adapted = !!iv.hasRoutedAround;
  if (hot && adapted) return 'C';
  if (hot) return 'A';
  if (adapted) return 'B';
  return null;
}
